export const flowsContent = `# Flows

## A) Free app (login only)

* Sign-up/Sign-in only.
* Grant \`has_access=true\` by default (or via your backend).
* \`autoShowPaywall=false\` (no paywall needed).

## B) Paid app (pay at sign-up)

* Configure a SKU that maps to \`has_access: true\`.
* Use \`handleLightswitchSignUp("/app")\` (includes checkout).
* Wrap paid areas with \`<ProtectedRoute>\` and set \`autoShowPaywall=true\`.`;
